import { render, staticRenderFns } from "./wtr-selection-dropdown.vue?vue&type=template&id=0ade8b06&scoped=true&"
import script from "./wtr-selection-dropdown.vue?vue&type=script&lang=js&"
export * from "./wtr-selection-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./wtr-selection-dropdown.vue?vue&type=style&index=0&id=0ade8b06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ade8b06",
  null
  
)

export default component.exports